import React, { useState } from "react";

import classNames from "classnames";

import {
  StyledStopwatch,
  StyledStopwatchCenterWrapper,
  StyledTrigger,
} from "./Stopwatch.style";
import { EditableHours } from "../EditableHours";
import { IconButton } from "../IconButton";
import {
  CloseIcon,
  NoteIcon,
  PauseSmallIcon,
  PlaySmallIcon,
  UploadIcon,
} from "../Icons";

export const Stopwatch = () => {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <StyledStopwatch
      className={classNames("", {
        "tw-bg-red-100": isActive,
        "tw-bg-gray-100": !isActive,
      })}
    >
      <IconButton
        onClick={() => setIsActive(!isActive)}
        className={classNames("tw-shadow-none hover:tw-shadow-none", {
          "tw-bg-red-400 hover:bg-red-500": isActive,
          "tw-bg-indigo-400 hover:bg-indigo-400": !isActive,
        })}
      >
        {!isActive ? <PlaySmallIcon /> : <PauseSmallIcon />}
      </IconButton>
      <StyledStopwatchCenterWrapper>
        <EditableHours value="00:00" />
        <IconButton size="small" variant="tertiary">
          <NoteIcon width={20} />
        </IconButton>
        {true && (
          <IconButton size="small" variant="tertiary">
            <CloseIcon width={20} />
          </IconButton>
        )}
      </StyledStopwatchCenterWrapper>
      <StyledTrigger onClick={() => setIsActive(!isActive)}>
        <UploadIcon />
      </StyledTrigger>
    </StyledStopwatch>
  );
};

Stopwatch.displayName = "Stopwatch";
